import React from 'react';
import type { OrganizationDetailsAppLayout as ServicedeskOrganizationDetailsType } from '@atlassian/jira-spa-apps-servicedesk-organization-details/src/ui/index.tsx';
import type { OrganizationsAppLayout as ServicedeskOrganizationsType } from '@atlassian/jira-spa-apps-servicedesk-organizations/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskOrganizations = lazyForPaint<typeof ServicedeskOrganizationsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-organizations", jiraSpaEntry: "async-servicedesk-organizations" */ '@atlassian/jira-spa-apps-servicedesk-organizations'
		),
	),
);

export const ServiceDeskOrganizations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOrganizations}
		pageId="spa-apps/servicedesk/organizations"
		shouldShowSpinner
	/>
);

export const LazyServicedeskOrganizationDetails = lazyForPaint<
	typeof ServicedeskOrganizationDetailsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-organization-details", jiraSpaEntry: "async-servicedesk-organization-details" */ '@atlassian/jira-spa-apps-servicedesk-organization-details'
		),
	),
);

export const ServicedeskOrganizationDetails = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOrganizationDetails}
		pageId="spa-apps/servicedesk/organization-details"
		shouldShowSpinner
	/>
);
